import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.js';
var IsURL = function IsURL(url) {
  var pattern = new RegExp('^((http|https):\\/\\/)?(([a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\\.[a-z]+)|((25[0-5]|2[0-4][0-9]|[1][0-9][0-9]|[1-9][0-9]|[0-9]?)(\\.(25[0-5]|2[0-4][0-9]|[1][0-9][0-9]|[1-9][0-9]|[0-9]?)){3}(:?[0-9]*)))(\\/.*)?$', 'i');
  return pattern.test(url);
};
var PathHelper = {
  ensureEndSlash: function ensureEndSlash(path) {
    return this.hasEndSlash(path) ? path : this.addEndSlash(path);
  },
  ensureStartSlash: function ensureStartSlash(path) {
    return this.hasStartSlash(path) ? path : this.addStartSlash(path);
  },
  ensureNoEndSlash: function ensureNoEndSlash(path) {
    return this.hasEndSlash(path) ? this.removeLastChar(path) : path;
  },
  ensureNoStartSlash: function ensureNoStartSlash(path) {
    return this.hasStartSlash(path) ? this.removeFirstChar(path) : path;
  },
  hasEndSlash: function hasEndSlash(path) {
    return path[path.length - 1] === '/';
  },
  addEndSlash: function addEndSlash(path) {
    return path + '/';
  },
  removeLastChar: function removeLastChar(path) {
    return path.slice(0, -1);
  },
  hasStartSlash: function hasStartSlash(path) {
    return path[0] === '/';
  },
  addStartSlash: function addStartSlash(path) {
    return '/' + path;
  },
  removeFirstChar: function removeFirstChar(path) {
    return path.substring(1, path.length);
  }
};
var getUrlVars = function getUrlVars(search) {
  if (!search) return {};
  return search.replace('?', '').split('&').reduce(function (acc, keyVal) {
    var _keyVal$split = keyVal.split('='),
      _keyVal$split2 = _slicedToArray(_keyVal$split, 2),
      key = _keyVal$split2[0],
      value = _keyVal$split2[1];
    if (key) {
      acc[key] = value;
    }
    return acc;
  }, {});
};
var getUrlDomain = function getUrlDomain() {
  var urlString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href;
  var _URL = new URL(urlString),
    hostname = _URL.hostname;
  return hostname.substring(hostname.lastIndexOf('.', hostname.lastIndexOf('.') - 1) + 1);
};

/** gets the currentRuleSetName from the window url */
var getCurrentRuleSetName = function getCurrentRuleSetName(currentUrl) {
  var location;
  if (typeof window === 'undefined') {
    if (!currentUrl) {
      return undefined;
    } else {
      location = new URL(currentUrl);
    }
  } else {
    location = window.location;
  }
  return new URLSearchParams(location.search).get('current_rule_set_name') || undefined;
};

/** returns the activeRuleSet or an empty object */
var getActiveRuleSetFromUrl = function getActiveRuleSetFromUrl(ruleSets, currentUrl) {
  if (!ruleSets) return {};
  var activeRuleSet = ruleSets === null || ruleSets === undefined ? undefined : ruleSets.find(function (currentRuleSet) {
    return currentRuleSet.active;
  });
  if (activeRuleSet) {
    return activeRuleSet;
  }
  var currentRuleSetName = getCurrentRuleSetName(currentUrl);
  return currentRuleSetName ? ruleSets.find(function (ruleSet) {
    if (ruleSet.name === currentRuleSetName) {
      ruleSet.active = true;
      return ruleSet;
    }
  }) : {};
};

/** returns the current business line using the currentRuleSetName
 *  if no valid ruleSets are provided, returns FALSE (for case where ruleSets haven't been fetched yet)
 *  returns undefined if there isn't a currentRuleSet
 */
var getCurrentBusinessLine = function getCurrentBusinessLine(ruleSets, currentRuleSetName) {
  if (!currentRuleSetName) {
    currentRuleSetName = getCurrentRuleSetName();
  }
  if (!currentRuleSetName) {
    return undefined;
  }
  if (!ruleSets) {
    return undefined;
  }
  var currentRuleSet = ruleSets.find(function (ruleSet) {
    return ruleSet.name === currentRuleSetName;
  });
  return currentRuleSet && (currentRuleSet.business_lines || []).join(',');
};
var loadScript = function loadScript(src) {
  return new Promise(function (resolve, reject) {
    try {
      var script = document.createElement('script');
      script.src = src;
      script.onload = function () {
        resolve();
      };
      script.onerror = function () {
        var failingFile = src.split('/').slice(-2).join('/');
        reject("An issue occured while trying to load the following file: ".concat(failingFile));
      };
      document.body.appendChild(script);
    } catch (e) {
      reject(e);
    }
  });
};
export { IsURL, PathHelper, getActiveRuleSetFromUrl, getCurrentBusinessLine, getCurrentRuleSetName, getUrlDomain, getUrlVars, loadScript };